import { takeEvery, fork, put, all, call } from 'redux-saga/effects';
import axios from "axios";

//Account Redux states
import { REGISTER_USER } from './actionTypes';
import { registerUserSuccessful, registerUserFailed } from './actions';

//AUTH related methods
import { postRegister } from '../../../helpers/fackBackend_Helper';
import { getFirebaseBackend } from '../../../helpers/firebase_helper';

// initialize firebase Auth
const fireBaseBackend = getFirebaseBackend();
const API_URL = process.env.API_BASE_URL

// Is user register successfull then direct plot user in redux.
function* registerUser({ payload: { user } }) {
    try {
        let response;

        if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
            response = yield call(
                fireBaseBackend.registerUser,
                user.email,
                user.password
            );
            yield put(registerUserSuccessful(response));
        } else {
            response = yield call(() =>
                axios.post(`${API_URL}/register`, {
                    name: user.username,
                    email: user.email,
                    password: user.password,
                })
            );


            localStorage.setItem("authUser", JSON.stringify(response.data));

            yield put(registerUserSuccessful(response.data));
            window.location.href = "/login";
        }
    } catch (error) {
        console.error("Register Error:", error);
        yield put(registerUserFailed(error.response?.data || error.message));
    }
}

export function* watchUserRegister() {
    yield takeEvery(REGISTER_USER, registerUser)
}

function* accountSaga() {
    yield all([fork(watchUserRegister)]);
}

export default accountSaga;